import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PlanService {

    static getPlan(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPlans}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getMyPlan(item) {

        let api = `${API_BASE_URL}${API_PATHS.getmyPlan}`;

        const params = new URLSearchParams();

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }


}

export default PlanService;
